import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { ValueChangedForFieldFunc } from '../../formeditor-types';
import FileAttachment from './FileAttachment';
import './FileAttachmentModal.scss';
import { ApplySendAFormInteractiveState } from '../SendAFormInteractiveState';

export interface FileAttachmentModalProps {
  name?: string;
  value?: string;
  valueUpdated?: ValueChangedForFieldFunc;
  onClose?: AnyFunc;
  sasToken?: TypeMePlease;
  fileUrls?: TypeMePlease;
  handleModalClose?: AnyFunc;
  maxFileSize?: number;
  maxFileCount?: number;
  allowedFileTypes?: string;
  view?: string;
  templateId?: string;
  templateName?: string;
  formId?: string;
  formName?: string;
  fieldId?: string;
  fieldName?: string;
  editable?: boolean;
}

export default function FileAttachmentModal(props: FileAttachmentModalProps) {
  return (
    <Modal open dimmer="inverted" closeOnDimmerClick={false} className="fileAttachment-modal">
      <Modal.Header>{props.name}</Modal.Header>
      <Modal.Content>
        <ApplySendAFormInteractiveState>
          <FileAttachment
            maxFileSize={props.maxFileSize}
            maxFileCount={props.maxFileCount}
            allowedFileTypes={props.allowedFileTypes}
            value={props.value}
            valueUpdated={props.valueUpdated}
            editable={props.editable}
            view={props.view}
            templateId={props.templateId}
            templateName={props.templateName}
            formId={props.formId}
            formName={props.formName}
            fieldId={props.fieldId}
            name={props.name}
          />
        </ApplySendAFormInteractiveState>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => props.onClose()} className="primary">
          Done
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
